import { createTheme } from "@mui/material"

const customTheme = createTheme({
    typography: {
        fontFamily: "MarkPro",
    },
    palette: {
        statiqOrange: {
            main: "#FC5735",
            contrastText: "#FFFFFF",
        },
        statiqBlue: {
            main: "#101941",
            contrastText: "#FFFFFF",
        },
        statiqGreen: {
            main: "#0AD274",
            contrastText: "#FFFFFF",
        },
    },
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    padding: "0px 3px",
                    height: "100%",

                    ".MuiFormControl-root": {
                        border: "none",
                    },
                },
                inputRoot: {
                    fontSize: "12px",
                    borderRadius: 0,
                    color: "#70758D",
                    paddingRight: "24px !important",
                    height: "100%",
                    borderBottom: "1px solid #E5E7EB",
                },
                popupIndicator: {
                    color: "#70758D",
                    "& svg": {
                        fontSize: "14px",
                    },
                },
                input: {
                    backgroundColor: "transparent",
                    minWidth: "54px !important",
                    padding: "4px !important",
                    borderBottom: "none",
                },
                paper: {
                    fontSize: "10px",
                },
                option: {
                    padding: "0px 12px",
                    marginBottom: "4px",
                    borderLeft: "2px solid transparent",
                    color: "#101941",
                    "&:last-child": {
                        marginBottom: "0px",
                    },
                    "&:hover": {
                        backgroundColor: "#E8E8Ec",
                        borderLeft: "2px solid #70758D",
                    },
                    '&[aria-selected="true"]': {
                        backgroundColor: "#E8E8Ec",
                        borderLeft: "2px solid #70758D",
                    },
                },
                clearIndicator: {
                    color: "#70758D",
                    "& svg": {
                        fontSize: "12px",
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    "&::before": {
                        borderBottom: "none",
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "none",
                    },
                    "&.Mui-focused:after": {
                        borderBottom: "none",
                    },
                    "&.Mui-focused:before": {
                        borderBottom: "none",
                    },
                },
                underline: {
                    "&:before, &:after": {
                        borderBottom: "none",
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "none",
                    },
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(232, 232, 236, 0.2)",
                    borderBottom: "1px solid #E5E7EB",
                    fontSize: "12px",
                    "&:hover": {
                        borderBottom: "1px solid rgba(229, 231, 235, 1)",
                        background: "rgba(232, 232, 236, 0.2)",
                    },
                },
                input: {
                    padding: "6px 8px",
                },
                underline: {
                    "&:before, &:after": {
                        borderBottom: "none",
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "none",
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    boxShadow: "none",
                    textTransform: "none",
                    padding: "4px 12px",
                    fontSize: "12px",
                    "&:hover": {
                        boxShadow: "none",
                    },
                    variants: [
                        {
                            props: {
                                variant: "light",
                            },
                            style: {
                                color: "#101941",
                                backgroundColor: "transparent",
                                padding: "4px 8px",
                                boxShadow: "-2px -2px 4px 0px rgba(0, 0, 0, 0.05), 2px 2px 4px 0px rgba(0, 0, 0, 0.05)",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                            },
                        },
                        {
                            props: {
                                variant: "outlined",
                            },
                            style: {
                                borderColor: "#70758D",
                                color: "#70758D",
                            },
                        },
                        {
                            props: {
                                variant: "outlined",
                                color: "statiqOrange",
                            },
                            style: {
                                borderColor: "#FC5735",
                                color: "#FC5735",
                            },
                        },
                        {
                            props: {
                                variant: "text",
                                size: "medium",
                            },
                            style: {
                                color: "#101941",
                                fontSize: "15px",
                                fontWeight: "500",
                                background: "transparent",
                                boxShadow: "none",
                            },
                        },
                        {
                            props: {
                                variant: "link",
                            },
                            style: {
                                color: "#0430C0",
                                backgroundColor: "transparent",
                                padding: "0px",
                                textDecoration: "underline",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                            },
                        },
                    ],
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    variants: [
                        {
                            props: {
                                variant: "label",
                            },
                            style: {
                                color: "#101941",
                                fontWeight: 500,
                                fontSize: "12px",
                                textTransform: "capitalize",
                            },
                        },
                        {
                            props: {
                                variant: "link",
                            },
                            style: {
                                color: "#0430c0",
                                cursor: "pointer",
                                textUnderlineOffset: 2,
                                fontSize: "12px",
                                textTransform: "capitalize",
                                textDecoration: "underline",
                            },
                        },
                    ],
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    variants: [
                        {
                            props: {
                                variant: "autocomplete",
                            },
                            style: {
                                fontSize: "10px",
                                height: "20px",
                                backgroundColor: "#E5E7EB",
                                borderRadius: "5.25px",
                                maxWidth: "110px !important",
                                gap: 2,
                                "& .MuiChip-label": {
                                    padding: "4px",
                                    textTransform: "capitalize",
                                },
                                "& .MuiChip-deleteIcon": {
                                    fontSize: "12px",
                                    color: "#777776",
                                },
                            },
                        },
                    ],
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: "12px",
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    boxShadow: "2px 2px 4px 0px rgba(207, 205, 205, 0.05), -2px -2px 4px 0px rgba(207, 205, 205, 0.05)",
                    borderRadius: "8px",
                    border: "1px solid #E3E8EE",
                },
                list: {
                    paddingTop: "4px",
                    paddingBottom: "4px",
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: "#101941",
                    padding: "4px",
                    "&.Mui-checked": {
                        color: "#101941",
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(232, 232, 236, 0.2)",
                    borderBottom: "1px solid #E5E7EB",

                    input: {
                        fontSize: "12px",
                        color: "#70758D",
                        padding: "4px",
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: "#FFFFFF",
                    color: "#101941",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                    fontSize: "11px",
                    display: "inline-block",
                    padding: "0.5rem",
                    borderRadius: "5px",
                },
                arrow: {
                    backgroundColor: "#fff",
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "12px",
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                colorPrimary: {
                    color: "#273054",
                },
                colorSecondary: {
                    color: "#FC5735",
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    backgroundColor: "#FFFFFF",
                    "&.Mui-selected": {
                        backgroundColor: "#101941",
                        color: "#FFFFFF",
                        "&:hover": {
                            backgroundColor: "#101941",
                            color: "#FFFFFF",
                        },
                    },
                    "&:hover": {
                        color: "#101941",
                    },
                },
                sizeSmall: {
                    padding: "4px 8px",
                    fontSize: "10px",
                    gap: "4px",
                },
            },
        },
    },
})

export default customTheme
